module.exports = __webpack_public_path__ + "img/icon_white_calendar.f45e1b38.svg";